define(["require", "exports", "Workspaces"], function (require, exports, Workspaces) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    require([
        "MainWorkspace/mainWorkspaceAppConfig",
        "ReportDesigner/reportDesignerAppConfig",
        "Project/projectAppConfig",
        "ViewUtilities/WindowHelper",
        "appConfig",
        "angular",
        //"angular-animate",
        "ResetPasswordController",
        "RegisterUserController",
        "angular-ui-router",
        "DataGrid/GridRowDoubleClick",
        "ViewUtilities/FontComponent",
        "ViewUtilities/ColorPicker",
        "ViewUtilities/ComboSearch",
        "ViewUtilities/AutoSizeHeight",
        "ViewUtilities/matchTextHeight",
        "ViewUtilities/CustomOnChangeDirective",
        "ViewUtilities/ngDragDrop",
        "ViewUtilities/ColorPicker2"
    ], function (mainConfig, reportDesignerConfig, projectAppConfig, windowHelper, config, angularLib) {
        mainConfig.config();
        reportDesignerConfig.config();
        projectAppConfig.config(Workspaces.mainProjectDetails);
        windowHelper.initialize();
        angularLib.bootstrap(document, ["appModule"]);
        console.debug("All js modules loaded.");
    });
});
//# sourceMappingURL=mainWorkspace.main.js.map